import {ModuleConfiguration} from "../router/model/UserPermission";
import {CustomerServiceModuleName} from "../utils/names/optionalModuleNames";
import {AngularJsMaterialModuleName, UtilsModuleName} from "../utils/names/requiredModulesNames";

export const CustomerServiceModuleConfiguration = new ModuleConfiguration(
    CustomerServiceModuleName,
    [CustomerServiceModuleName, AngularJsMaterialModuleName, UtilsModuleName]);